module.exports = __webpack_public_path__ + "img/header.33fce715.png";